export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || process.env.API_BASE_URL || '';
export const ADMIN_BEARER_TOKEN = process.env.NEXT_PUBLIC_ADMIN_BEARER_TOKEN ?? '';
export const API_AUTH_SCHEME = process.env.NEXT_PUBLIC_API_AUTH_SCHEME ?? '';
